import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _some from "lodash/some";
import _each from "lodash/each";
import _get from "lodash/get";
import moment from 'moment';
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { editTransaction, resetTransactions, getTransactions, getNextTransactionsPage, updateFinancialAccountVisibility, getDailyAverageTransactionsCashFlow, getDailyTransactionsCashFlow, getTopMerchants, getCashFlowProjection, getCategoryWindowRollups, getTransactionsMonthCashFlow, createTransactionTag, deleteTransactionTag, recategorizeTransaction, createMerchantCategoryRule } from "../actions/yodlee";
import { TOP_MERCHANTS_REQUEST_LIMIT } from "../constants/yodlee";
import { DATE_FORMAT } from "../constants";
import { makeGetTransactionById, getViewFilter, getMonthsWithCategoriesForRollupsAfterMerchantCategoryRule } from "../selectors/yodlee";
import { isSpendingTransactionCategory } from "../utils/yodlee";
var getTransactionById = makeGetTransactionById();

function refetchBaseRollups(dispatch) {
  var TODAY = moment().format(DATE_FORMAT.STANDARD);
  var lastMonthMoment = moment().subtract(1, 'month');
  var threeMonthsAgoMoment = moment().subtract(3, 'month');
  dispatch(getDailyTransactionsCashFlow({
    dayInTargetMonth: TODAY
  }));
  dispatch(getTransactionsMonthCashFlow({
    dayInTargetMonth: TODAY
  }));
  dispatch(getDailyAverageTransactionsCashFlow({
    dayInStartMonth: moment(threeMonthsAgoMoment).startOf('month').format(DATE_FORMAT.STANDARD),
    dayInEndMonth: moment(lastMonthMoment).endOf('month').format(DATE_FORMAT.STANDARD)
  }));
  dispatch(getCategoryWindowRollups({
    startDate: moment().startOf('month').format(DATE_FORMAT.STANDARD),
    endDate: moment().endOf('month').format(DATE_FORMAT.STANDARD)
  }));
  dispatch(getTopMerchants({
    startDate: moment().subtract(30, 'days').format(DATE_FORMAT.STANDARD),
    endDate: moment().format(DATE_FORMAT.STANDARD),
    includeSlices: [NwApiSDK.IDENTITY_TRANSACTION_SLICES.WINDOW],
    limit: TOP_MERCHANTS_REQUEST_LIMIT
  }));
  dispatch(getCashFlowProjection({
    dayInTargetMonth: moment().format(DATE_FORMAT.STANDARD)
  }));
}

function resetAndUpdateTransactions(state, dispatch) {
  dispatch(resetTransactions());
  dispatch(getNextTransactionsPage());
  refetchBaseRollups(dispatch);
}

export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      if (!process.browser) return next(action);
      var returnValue = next(action);
      var nextState = getState(); // If the user hides/shows an account then we need to reset everything and start over

      if (action.type === updateFinancialAccountVisibility.SUCCESS_TYPE) {
        resetAndUpdateTransactions(nextState, dispatch);
        return returnValue;
      }

      if (action.type === createTransactionTag.SUCCESS_TYPE || action.type === deleteTransactionTag.SUCCESS_TYPE) {
        var _action$meta = action.meta,
            transactionId = _action$meta.transactionId,
            tag = _action$meta.tag;

        if (tag === NwApiSDK.IDENTITY_TRANSACTION_TAGS.IGNORED) {
          refetchBaseRollups(dispatch);
          var transaction = getTransactionById(nextState.identity, {
            transactionId: transactionId
          });
          var firstOfThisMonth = moment().date(1).format(DATE_FORMAT.STANDARD);

          var date = _get(transaction, 'date');

          var rollupDate = moment(date).date(1).format(DATE_FORMAT.STANDARD);
          var viewFilter = getViewFilter(nextState.identity);

          if (rollupDate !== firstOfThisMonth) {
            dispatch(getTransactionsMonthCashFlow({
              dayInTargetMonth: rollupDate
            }));
          }

          if (viewFilter) {
            dispatch(getTransactionsMonthCashFlow({
              dayInTargetMonth: rollupDate,
              filter: viewFilter
            }));
          }
        }
      }

      if (action.type === recategorizeTransaction.SUCCESS_TYPE) {
        // if a transaction is recategorized as a non-spending category, we need to refetch rollups for that date
        var _action$meta2 = action.meta,
            category = _action$meta2.category,
            previousCategory = _action$meta2.previousCategory,
            _date = _action$meta2.date;
        var dateMoment = moment(_date, DATE_FORMAT.STANDARD);
        var todayMoment = moment();

        if (!isSpendingTransactionCategory(category) || !isSpendingTransactionCategory(previousCategory)) {
          var lastMonthMoment = moment().subtract(1, 'month');
          var thirtyDaysAgoMoment = moment().subtract(30, 'days');

          if (dateMoment.isSame(todayMoment, 'month')) {
            refetchBaseRollups(dispatch);
          } else if (dateMoment.isSame(lastMonthMoment, 'month')) {
            dispatch(getTransactionsMonthCashFlow({
              dayInTargetMonth: lastMonthMoment.format(DATE_FORMAT.STANDARD)
            }));
            dispatch(getDailyTransactionsCashFlow({
              dayInTargetMonth: moment(lastMonthMoment).endOf('month').format(DATE_FORMAT.STANDARD)
            }));

            if (dateMoment.isAfter(thirtyDaysAgoMoment)) {
              dispatch(getTopMerchants({
                startDate: thirtyDaysAgoMoment.format(DATE_FORMAT.STANDARD),
                endDate: todayMoment.format(DATE_FORMAT.STANDARD),
                includeSlices: [NwApiSDK.IDENTITY_TRANSACTION_SLICES.WINDOW],
                limit: TOP_MERCHANTS_REQUEST_LIMIT
              }));
            }
          }
        }
      }

      if (action.type === editTransaction.SUCCESS_TYPE) {
        // if a transaction is now or was before a spending category, we
        // need to refetch rollups
        var _action$meta3 = action.meta,
            _date2 = _action$meta3.date,
            previousDate = _action$meta3.previousDate;

        var _todayMoment = moment();

        var _dateMoment = moment(_date2, DATE_FORMAT.STANDARD);

        var previousDateMoment = moment(previousDate, DATE_FORMAT.STANDARD);

        var _lastMonthMoment = moment().subtract(1, 'month');

        var threeMonthsAgoMoment = moment().subtract(3, 'month');

        var _thirtyDaysAgoMoment = moment().subtract(30, 'days');

        if (_dateMoment.isSame(_todayMoment, 'month') || previousDateMoment.isSame(_todayMoment, 'month')) {
          refetchBaseRollups(dispatch);
        } else if (_dateMoment.isSame(_lastMonthMoment, 'month') || previousDateMoment.isSame(_lastMonthMoment, 'month')) {
          dispatch(getTransactionsMonthCashFlow({
            dayInTargetMonth: _lastMonthMoment.format(DATE_FORMAT.STANDARD)
          }));
          dispatch(getDailyTransactionsCashFlow({
            dayInTargetMonth: moment(_lastMonthMoment).endOf('month').format(DATE_FORMAT.STANDARD)
          }));
          dispatch(getDailyAverageTransactionsCashFlow({
            dayInStartMonth: moment(threeMonthsAgoMoment).startOf('month').format(DATE_FORMAT.STANDARD),
            dayInEndMonth: moment(_lastMonthMoment).endOf('month').format(DATE_FORMAT.STANDARD)
          }));

          if (_dateMoment.isAfter(_thirtyDaysAgoMoment) || previousDateMoment.isAfter(_thirtyDaysAgoMoment)) {
            dispatch(getTopMerchants({
              startDate: _thirtyDaysAgoMoment.format(DATE_FORMAT.STANDARD),
              endDate: _todayMoment.format(DATE_FORMAT.STANDARD),
              includeSlices: [NwApiSDK.IDENTITY_TRANSACTION_SLICES.WINDOW],
              limit: TOP_MERCHANTS_REQUEST_LIMIT
            }));
          }
        }
      }

      if (action.type === createMerchantCategoryRule.SUCCESS_TYPE) {
        var _action$meta4 = action.meta,
            _transactionId = _action$meta4.transactionId,
            canonicalMerchantName = _action$meta4.canonicalMerchantName,
            _previousCategory = _action$meta4.previousCategory;
        var needRollupsMap = getMonthsWithCategoriesForRollupsAfterMerchantCategoryRule(nextState.identity, {
          transactionId: _transactionId,
          canonicalMerchantName: canonicalMerchantName,
          previousCategory: _previousCategory
        });

        var _todayMoment2 = moment();

        var _lastMonthMoment2 = moment().subtract(1, 'month');

        var _thirtyDaysAgoMoment2 = moment().subtract(30, 'days'); // for each month in which a transaction was recategorized


        _each(Object.keys(needRollupsMap), function (date) {
          var dateMoment = moment(date);
          var formattedDateMoment = dateMoment.format(DATE_FORMAT.STANDARD);
          var categories = needRollupsMap[date].categories;

          if (dateMoment.isSameOrAfter(_lastMonthMoment2, 'month')) {
            if (_some(categories, function (category) {
              return !isSpendingTransactionCategory(category);
            })) {
              if (dateMoment.isSame(_todayMoment2, 'month')) {
                refetchBaseRollups(dispatch);
              } else if (dateMoment.isSame(_lastMonthMoment2, 'month')) {
                dispatch(getTransactionsMonthCashFlow({
                  dayInTargetMonth: formattedDateMoment
                }));

                if (dateMoment.isAfter(_thirtyDaysAgoMoment2)) {
                  dispatch(getTopMerchants({
                    startDate: _thirtyDaysAgoMoment2.format(DATE_FORMAT.STANDARD),
                    endDate: _todayMoment2.format(DATE_FORMAT.STANDARD),
                    includeSlices: [NwApiSDK.IDENTITY_TRANSACTION_SLICES.WINDOW],
                    limit: TOP_MERCHANTS_REQUEST_LIMIT
                  }));
                }
              }
            }
          }
        });
      }

      if (action.type !== getTransactions.SUCCESS_TYPE) {
        return returnValue;
      } // If transactions are ever out of sync (i.e. when Identity syncs with Yodlee)
      // we need to reset everything and start over


      if (getState().identity.yodlee.transactions.transactionsOutdated) {
        resetAndUpdateTransactions(nextState, dispatch);
      }

      return returnValue;
    };
  };
});